/** Wrap-around index for circular carousel navigation */
export function wrapIndex(index: number, length: number): number {
  if (length === 0) return 0
  return ((index % length) + length) % length
}

/** Shortest-path offset so cards always take the nearest route */
export function getOffset(idx: number, activeIndex: number, length: number): number {
  if (length === 0) return 0
  let offset = idx - activeIndex
  if (offset > length / 2) offset -= length
  if (offset < -length / 2) offset += length
  return offset
}

/**
 * Visual target per slot — all cards are the center size (276×300).
 * x is distance from container center (container is 700px → center at 350px).
 * Cards use left:50% + ml:-138 so x=0 puts card centered; ±244 puts it at the side slot.
 */
export function getSlotTarget(offset: number) {
  const abs = Math.abs(offset)
  if (abs === 0) {
    return { x: 0, y: -36, scale: 1, rotate: 0, opacity: 1 }
  }
  if (abs === 1) {
    const sign = Math.sign(offset)
    return { x: sign * 244, y: 0, scale: 0.884, rotate: sign * 4, opacity: 0.9 }
  }
  const sign = Math.sign(offset)
  return { x: sign * 520, y: 0, scale: 0.7, rotate: sign * 8, opacity: 0 }
}

export function getZIndex(offset: number): number {
  const abs = Math.abs(offset)
  if (abs === 0) return 20
  if (abs === 1) return 10
  return 0
}
